<template>
<v-menu
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
>
   <template v-slot:activator="{on}">
     <slot name="activator" :show="show" :on="on"></slot>
   </template>
  <v-list class="pt-0">
    <v-toolbar class="pt-0" flat dense>
      <div class="subtitle font-weight-bold">Sample Context Menu</div>
      <v-spacer></v-spacer>
      <v-btn icon @click="showMenu = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list-item @click="copyToClipboard(sample.id)" link>
      <v-list-item-content>
        <v-list-item-title>Copy Sample ID</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item @click="printLabel(sample)" link>
      <v-list-item-content>
<!--        <v-btn @click="printLabel(item)" @contextmenu="show" small outlined tile>Print Label</v-btn>-->
        <v-list-item-title>Print Label</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-menu offset-x open-on-hover :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-list-item v-on="on" link>
          <v-list-item-content>
            <v-list-item-title>Flags</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon small>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </template>
      <v-list dense style="max-height: 300px; overflow-y: auto;">
        <v-list-item
          v-for="flagType in sampleFlagTypes"
          :key="flagType.uuid"
          @click="toggleFlag(flagType)"
          link
        >
          <v-list-item-action class="mr-2">
            <v-simple-checkbox
              :value="hasFlag(flagType)"
              @click.stop="toggleFlag(flagType)"
            ></v-simple-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <v-chip :color="flagType.color || 'primary'" small class="white--text mr-1" label>
                {{ flagType.name }}
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="sampleFlagTypes.length === 0">
          <v-list-item-content>
            <v-list-item-subtitle class="text--secondary">No flags available</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-divider></v-divider>
    <SdpView v-if="sample.qa_approved && sample.is_released" :sample_id="sample.id">
      <template v-slot:activator="{on}">
        <SdpButton v-on="on" :sample_id="sample.id" list_item></SdpButton>
      </template>
    </SdpView>
<!--    <SdpButton :sample_id="sample.id"></SdpButton>-->
<!--    <v-list-item link>-->
<!--      <v-list-item-content>-->
<!--        <v-list-item-title>Copy ConAn Link</v-list-item-title>-->
<!--      </v-list-item-content>-->
<!--    </v-list-item>-->
<!--    <v-divider></v-divider>-->
    <v-list-item :href="`https://wa.belit.conflabs.com/directory_v2/${sample.customer_id}`" target="_blank" link>
      <v-list-item-content>
        <v-list-item-title>Go to customer directory</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
<!--    <v-divider></v-divider>-->
<!--    <v-list-item link>-->
<!--      <v-list-item-content>-->
<!--        <v-list-item-title>Send to Slack</v-list-item-title>-->
<!--        <v-list-item-subtitle>Ask ConAn to send a note about this sample to a slack channel</v-list-item-subtitle>-->
<!--      </v-list-item-content>-->
<!--    </v-list-item>-->
  </v-list>
</v-menu>
</template>

<script>
// import FrontOfficeLabel from "@/Lib/Labels/FrontOfficeLabel";
// import Label from "@/Lib/LabelPrinter";
import SdpView from '@/components/SDP/SdpView'
import SdpButton from '@/components/SDP/SdpButton'
export default {
    name: "SampleContextMenu",
    components: {
      SdpView,
      SdpButton,
    },
    data: () => ({
      showMenu: false,
      x: 0,
      y: 0,
    }),
    props: {
      sample: {
        required: true,
      }
    },
    computed: {
      sampleFlagTypes() {
        let flags = this.$store.$db().model('sampleFlagTypes').query().orderBy("display_index").all();
        let filtered = this.$store.state.filtered_flags || this.$store.state.manifest_filtered_flags || [];
        if (filtered.length > 0) {
          return flags.filter(flag => !filtered.includes(flag.uuid));
        }
        return flags;
      }
    },
    methods: {
      show (e) {
        e.preventDefault()
        this.showMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      },
      hasFlag(flagType) {
        if (!this.sample || !this.sample.sample_flags) return false;
        return this.sample.sample_flags.some(
          sf => sf.sample_flag_type_uuid === flagType.uuid || (sf.flag_type && sf.flag_type.uuid === flagType.uuid)
        );
      },
      async toggleFlag(flagType) {
        if (!this.sample || !this.sample.uuid) return;
        const existing = (this.sample.sample_flags || []).find(
          sf => sf.sample_flag_type_uuid === flagType.uuid || (sf.flag_type && sf.flag_type.uuid === flagType.uuid)
        );
        if (existing) {
          try {
            await this.$store.$db().model('sampleFlags').api().destroy(existing.uuid, "Delete flag: " + flagType.name);
            this.$store.dispatch("showSuccess", "Removed flag: " + flagType.name);
          } catch (e) {
            this.$store.dispatch("showError", "Failed to remove flag");
          }
        } else {
          try {
            await this.$store.$db().model('sampleFlags').api().save({
              collection: [{
                uuid: null,
                sample_flag_type_uuid: flagType.uuid,
                sample_uuid: this.sample.uuid,
                created_by: this.$store.getters.id,
              }]
            });
            this.$store.dispatch("showSuccess", "Added flag: " + flagType.name);
          } catch (e) {
            this.$store.dispatch("showError", "Failed to add flag");
          }
        }
      },
      printLabel(sample){
        // this.$store.$db().model('samples').query().where('id', sample.id).first()
        // this.label.setPrinter();
        // this.label = new Label(dymo);
        this.$store.state.dymo.setLabel("FrontOfficeLabel");
        sample = this.$store.state.dymo.labelFormat(this.$store.$db().model('samples').query().where('id', sample.id).first());
        this.$store.state.dymo.createLabels(sample);
        this.$store.state.dymo.print()
      },
      fallBackCopyToClipboard(text){
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          let successful = document.execCommand('copy');
          if(successful){
            this.$store.dispatch("showSuccess", "Copied to Clipboard!")
          }
        } catch (err) {
          this.$store.dispatch("showError", "An error occurred while trying to copy something.")
        }

        document.body.removeChild(textArea);
      },
      async copyToClipboard(text){
        if (!navigator.clipboard) {
          this.fallBackCopyToClipboard(text);
          return;
        }
        navigator.clipboard.writeText(text).then(() => {
          this.$store.dispatch("showSuccess", "Copied to Clipboard!")
        }, (err) => {
          this.$store.dispatch("showError", "An error occurred while trying to copy something.")
        });
      }
    }
}
</script>

<style scoped>

</style>
